import * as Types from './messaging_gql.generated';

import { gql } from 'graphql.macro';
import * as Apollo from '@apollo/client';
export type OnMessageUpdateSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type OnMessageUpdateSubscription = (
  { __typename?: 'Subscriptions' }
  & { onMessageUpdate?: Types.Maybe<(
    { __typename?: 'MessageNode' }
    & Pick<Types.MessageNode, 'uuid' | 'content' | 'readAt' | 'conversationUuid'>
  )> }
);


export const OnMessageUpdateDocument = gql`
    subscription onMessageUpdate {
  onMessageUpdate {
    uuid
    content
    readAt
    conversationUuid
  }
}
    `;
export type OnMessageUpdateSubscriptionResult = Apollo.SubscriptionResult<OnMessageUpdateSubscription>;